import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      meta: {
        requireAuth: false
      },
      component: () => import("../views/home.vue")
    },
    {
      path: "/products",
      name: "products",
      meta: {
        requireAuth: false
      },
      component: () => import("../views/products.vue")
    },
    {
      path: "/product",
      name: "product",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/product/list.vue")
    },
    {
      path: "/business/chargerole",
      name: "chargeRole",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/business/chargeRole.vue")
    },
    {
      path: "/device_type",
      name: "device_type",
      meta: {
        requireAuth: false
      },
      component: () => import("../views/device_type/list.vue")
    },
    {
      path: "/shop/product",
      name: "shopProduct",
      meta: {
        requireAuth: false
      },
      component: () => import("../views/shop/product.vue")
    },
    {
      path: "/service/list",
      name: "serviceList",
      meta: {
        requireAuth: false
      },
      component: () => import("../views/service/list.vue")
    },
    {
      path: "/business/recharge",
      name: "recharge",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/business/recharge.vue")
    },
    {
      path: "/business/message",
      name: "message",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/business/message.vue")
    },
    {
      path: "/business/list",
      name: "list",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/business/list.vue")
    },
    {
      path: "/business/status",
      name: "status",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/business/status.vue")
    },
    {
      path: "/wechat/list",
      name: "wechatList",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/wechat/list.vue")
    },
    {
      path: "/system/role",
      name: "role",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/system/role.vue")
    },
    {
      path: "/system/account",
      name: "account",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/system/account.vue")
    },
    {
      path: "/user/index",
      name: "user",
      component: () => import("../views/user/index.vue")
    },
    {
      //电动自行车智能交流充电柜
      path: "/business/status1",
      name: "status1",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/business/status1.vue")
    },
    {
      //智能电箱控制器实时状态卡
      path: "/business/status2",
      name: "status2",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/business/status2.vue")
    },
    {
      //智能太阳能监控实时状态卡
      path: "/business/status3",
      name: "status3",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/business/status3.vue")
    },
    {
      //智能太阳能路灯监控实时状态卡
      path: "/business/status4",
      name: "status4",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/business/status4.vue")
    },
    {
      //智能太阳能路灯监控实时状态卡
      path: "/business/status6",
      name: "status6",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/business/status6.vue")
    },
    {
      //电动自行车智能交流充电柜实时状态卡
      path: "/business/status5",
      name: "status5",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/business/status5.vue")
    },
    {
      //订单查询
      path: "/business/order",
      name: "order",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/order/list.vue")
    },
    {
      //系统设置
      path: "/system/setting",
      name: "setting",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/system/setting.vue")
    },
    {
      //服务
      path: "/service",
      name: "service",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/service.vue")
    },
    {
      //服务
      path: "/service_post",
      name: "service_post",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/service_post.vue")
    },
    {
      //服务
      path: "/service_active",
      name: "service_active",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/service_active.vue")
    },
    {
      //登录
      path: "/login",
      name: "login",
      meta: {
        requireAuth: false
      },
      component: () => import("../views/login/login.vue")
    },
    {
      //登录
      path: "/board",
      name: "board",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/board.vue")
    },
    {
      //登录
      path: "/board_new",
      name: "board_new",
      meta: {
        requireAuth: false
      },
      component: () => import("../views/board_new.vue")
    },
    {
      //登录
      path: "/board_new_sz",
      name: "board_new_sz",
      meta: {
        requireAuth: false
      },
      component: () => import("../views/board_new_sz.vue")
    },
    {
      //主界面
      path: "/statistics",
      name: "statistics",
      meta: {
        requireAuth: true
      },
      component: () => import("../views/statistics.vue")
    }
  ]
});
